import { Controller } from '@hotwired/stimulus';

/**
 * On modal `hide`, remove the element with the selector value.
 * The selector can be for an element anywhere on the page.
 * This controller must be connected to an element inside the default remote modal
 */
export default class extends Controller {
  static values = { selector: String };

  connect() {
    const modalEl = this.element.closest('#turbo-modal');

    if (modalEl && this.hasSelectorValue) {
      modalEl.addEventListener(
        'hide.bs.modal',
        () => {
          const navItems = document.querySelectorAll(this.selectorValue);
          navItems.forEach((item) => item?.remove());
        },
        { once: true }
      );
    }
  }
}
